import { isLogin, forceLogin, env } from '@didi/public-sdk'

// const URL_PARAM = query.resolveQuery(location.href)
const ENV = process.env.NODE_ENV === 'production' ? 'prod' : 'dev'

let auth = {
  userInfo: {}
}

function login(isForcePop = false) {
  return new Promise((resolve, reject) => {
    // if (URL_PARAM.token) {
    //   const res = {
    //     token: URL_PARAM.token
    //   }
    //   auth.set(res)
    //   resolve(res)
    //   return
    // }
    if (!env.isDriver && window.Fusion && window.Fusion.getUserInfo) {
      window.Fusion.getUserInfo({}, (ret) => {
        auth.set(ret)
        resolve(ret)
      })
      return
    }

    isLogin({
      env: ENV
    }, (err, outerRes) => {
      if (outerRes && outerRes.token) {
        auth.set(outerRes)
        resolve(outerRes)
      } else {
        if (isForcePop) {
          forceLogin({
            env: ENV
          }, (innerErr, innerRes) => {
            if (innerRes && innerRes.token) {
              auth.set(innerRes)
              resolve(innerRes)
            } else {
              reject(innerErr)
            }
          })
        } else {
          reject(err)
        }
      }
    })
  })
}

auth.login = login
auth.get = function(key) {
  return this.userInfo[key]
}
auth.set = function(res) {
  this.userInfo = res
}

export default auth
